var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook 1",
    clipPath: "url(#clip0_11_101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99875 2.85603H9.09425V0.948025C8.90525 0.922025 8.25525 0.863525 7.49825 0.863525C5.91875 0.863525 4.83675 1.85703 4.83675 3.68303V5.36353H3.09375V7.49653H4.83675V12.8635H6.97375V7.49703H8.64625L8.91175 5.36403H6.97325V3.89453C6.97375 3.27803 7.13975 2.85603 7.99875 2.85603Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.863525)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook1);
export default __webpack_public_path__ + "static/media/facebook 1.5d12a0afddd96bc5716faffd298def35.svg";
export { ForwardRef as ReactComponent };